import { GuaranteeApplication } from '@lib/prescriptions/data-access';
import { Prescription, PrescriptionHistoryStatus } from '@lib/prescriptions/data-access';

import { PagedResponse } from '@lib/core/models/paged-response';

import { generateObjectChanges } from '@lib/shared-ui/core/utils/generate-object-changes.function';

export function generateHistoricalPrescriptionsByDate(pagedResponse: PagedResponse<GuaranteeApplication>) {
  return pagedResponse.value.map(guarantee => {
    const prescriptions: Prescription[] = [...guarantee.prescriptions];
    const activePrescriptions: Prescription[] = prescriptions
      .filter(p => p.historyStatus === PrescriptionHistoryStatus.Active)
      .map(prescription => {
        const historicalPrescriptions: Prescription[] = prescriptions.filter(p => p.originalPrescriptionId === prescription.originalPrescriptionId);
        return {
          ...prescription,
          historicalChanges: generateObjectChanges(historicalPrescriptions, 'lastUpdateDate'),
        };
      });
    return {
      ...guarantee,
      prescriptions: activePrescriptions,
    };
  });
}
